/*
 * yc-story.js
 * Custom element for the Story band video.
 * Clicking the play button reveals native controls, starts playback and
 * hides the button. Accessible (keyboard-operable button) and quiet on
 * autoplay failures.
 */
(function () {
  if (customElements.get('yc-story-video')) return;

  class YcStoryVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.button = this.querySelector('.yc-story__play');
      if (!this.video || !this.button) return;

      this._onClick = this.play.bind(this);
      this.button.addEventListener('click', this._onClick);
    }

    disconnectedCallback() {
      if (this.button && this._onClick) {
        this.button.removeEventListener('click', this._onClick);
      }
    }

    /*
     * Promotes every `data-video-source` to a real `src`.
     *
     * The markup ships without one, so nothing is fetched while the page is
     * parsing. This runs on the play click — which is itself the visitor's
     * interaction — so the gate costs nothing: `preload="none"` already meant no
     * media bytes moved until play, and the browser now has no URL to reach for
     * before that either. Idempotent; the first call empties the dataset.
     */
    promoteSources() {
      if (!this.video || this._promoted) return;
      this._promoted = true;

      var sources = this.video.querySelectorAll('source[data-video-source]');
      if (!sources.length) return;

      for (var i = 0; i < sources.length; i++) {
        sources[i].setAttribute('src', sources[i].getAttribute('data-video-source'));
        sources[i].removeAttribute('data-video-source');
      }

      this.video.load();
    }

    play() {
      if (!this.video) return;
      this.promoteSources();
      this.video.controls = true;

      var playing = this.video.play();
      if (playing && typeof playing.catch === 'function') {
        playing.catch(function () {});
      }

      this.button.classList.add('is-hidden');
      // Drop the lazy poster overlay once real frames are on screen.
      this.classList.add('is-playing');

      // Move focus to the video so keyboard users can operate the controls.
      if (typeof this.video.focus === 'function') {
        this.video.setAttribute('tabindex', '-1');
        this.video.focus();
      }
    }
  }

  customElements.define('yc-story-video', YcStoryVideo);
})();
